// types.ts
export interface LocationData {
  state: string;
  cities: string[];
}

export const nigeriaStates = [
  "Abia",
  "Abuja",
  "Adamawa",
  "Akwa Ibom",
  "Anambra",
  "Bauchi",
  "Bayelsa",
  "Benue",
  "Borno",
  "Cross River",
  "Delta",
  "Ebonyi",
  "Edo",
  "Ekiti",
  "Enugu",
  "Imo",
  "Jigawa",
  "Kaduna",
  "Kano",
  "Katsina",
  "Kebbi",
  "Kogi",
  "Kwara",
  "Lagos",
  "Nasarawa",
  "Niger",
  "Ogun",
  "Ondo",
  "Osun",
  "Oyo",
  "Plateau",
  "Rivers",
  "Sokoto",
  "Yobe",
  "Zamfara",
];

export const nigeriaLocations: LocationData[] = [
  {
    state: "Abia",
    cities: ["Aba", "Isiala Ngwa", "Obi Ngwa", "Osisioma Ngwa", "Umuahia"],
  },
  {
    state: "Abuja",
    cities: [
      "Apo",
      "Asokoro District",
      "Bwari",
      "Central Area Phase 2",
      "Central Business District",
      "Cultural Zones",
      "Dakibiyu",
      "Dakwo",
      "Dape",
      "Dawaki",
      "Dei-Dei",
      "Diplomatic Zones",
      "Duboyi",
      "Durumi",
      "Dutse",
      "Gaduwa",
      "Galadimawa",
      "Garki",
      "Gudu",
      "Guzape District",
      "Gwagwalada",
      "Gwarinpa",
      "Idu Industrial",
      "Institution and Research",
      "Jabi",
      "Jahi",
      "Jikwoyi",
      "Kaba",
      "Kabusa",
      "Kado",
      "Kafe",
      "Kagini",
      "Karmo",
      "Karsana",
      "Karshi",
      "Karu",
      "Katampe",
      "Kaura",
      "Kpeyegyi",
      "Kubwa",
      "Kuje",
      "Kukwaba",
      "Kurudu",
      "Kwali",
      "Kyami",
      "Life Camp",
      "Lokogoma District",
      "Lugbe District",
      "Mabushi",
      "Maitama District",
      "Mararaba",
      "Mbora (Nbora)",
      "Mpape",
      "Nyanya",
      "Orozo",
      "Sabo Gida",
      "Sheretti",
      "Utako",
      "Wumba",
      "Wupa",
      "Wuse",
      "Wuse 2",
      "Wuye",
      "Zuba",
    ],
  },
  {
    state: "Adamawa",
    cities: ["Yola", "Fufore", "Ganye"],
  },
  {
    state: "Akwa Ibom",
    cities: [
      "Abak",
      "Eket",
      "Etinan",
      "Ibesikpo-Asutan",
      "Ikot Abasi",
      "Ikot Ekpene",
      "Itu",
      "Mbo",
      "Nsit-Ibom",
      "Oron",
      "Uruan",
      "Uyo",
    ],
  },
  {
    state: "Anambra",
    cities: ["Anambra", "Awka", "Njikoka", "Nnewi", "Onitsha", "Orumba"],
  },
  {
    state: "Bauchi",
    cities: ["Gamawa", "Bauchi"],
  },
  {
    state: "Bayelsa",
    cities: ["Ogbia", "Sagbama", "Yenagoa"],
  },
  {
    state: "Benue",
    cities: ["Ado", "Apa", "Makurdi", "Ogbadibo", "Oju"],
  },
  {
    state: "Borno",
    cities: ["Jere", "Kukawa", "Maiduguri"],
  },
  {
    state: "Cross River",
    cities: [
      "Calabar",
      "Ikom",
      "Ogoja",
      "Obudu",
      "Ugep",
      "Bekwarra",
      "Akpabuyo",
      "Biase",
      "Etung",
      "Yakurr",
      "Obubra",
      "Abi",
      "Akamkpa",
      "Boki",
      "Yala",
      "Bakassi",
    ],
  },
  {
    state: "Delta",
    cities: [
      "Abraka",
      "Aniocha North",
      "Aniocha South",
      "Asaba",
      "Bomadi",
      "Burutu",
      "Ethiope East",
      "Ethiope West",
      "Ika North East",
      "Ika South",
      "Okpe",
      "Patani",
      "Oshimili North",
      "Oshimili South",
      "Sapele",
      "Udu",
      "Ughelli North",
      "Ughelli South",
      "Uvwie",
      "Warri",
    ],
  },
  {
    state: "Ebonyi",
    cities: ["Abakaliki", "Ezza", "Ishielu"],
  },
  {
    state: "Edo",
    cities: [
      "Egor",
      "Esan Central",
      "Esan West",
      "Etsako West",
      "Igueben",
      "Ikpoba Okha",
      "Oredo",
      "Ovia North-East",
      "Uhunmwonde",
    ],
  },
  {
    state: "Ekiti",
    cities: ["Ado-Ekiti", "Ekiti South-West", "Ikere", "Oye"],
  },
  {
    state: "Enugu",
    cities: [
      "Aninri",
      "Awgu",
      "Enugu",
      "Ezeagu",
      "Isi Uzo",
      "Nkanu",
      "Nsukka",
      "Oji River",
      "Udi",
      "Uzo Uwani",
    ],
  },
  {
    state: "Imo",
    cities: [
      "Ezinihitte Mbaise",
      "Ikeduru",
      "Mbaitoli",
      "Ngor Okpala",
      "Nwangele",
      "Ohaji/Egbema",
      "Okigwe",
      "Orlu",
      "Owerri Municipal",
      "Owerri North",
      "Owerri West",
    ],
  },
  {
    state: "Jigawa",
    cities: ["Dutse", "Guri", "Jahun", "Maigatari"],
  },
  {
    state: "Kaduna",
    cities: ["Chikun", "Kaduna North", "Kaduna South", "Zaria"],
  },
  {
    state: "Kano",
    cities: [
      "Bebeji",
      "Bichi",
      "Dala",
      "Dawakin Kudu",
      "Dawakin Tofa",
      "Fagge",
      "Gaya",
      "Garko",
      "Garun Mallam",
      "Kano",
      "Kano Municipal",
      "Karaye",
      "Kibiya",
      "Kunchi",
      "Madobi",
      "Makoda",
      "Nasarawa",
      "Rimin Gado",
      "Tarauni",
      "Tofa",
      "Ungogo",
      "Warawa",
      "Wudil",
    ],
  },
  {
    state: "Katsina",
    cities: [
      "Bakori",
      "Batagarawa",
      "Batsari",
      "Bindawa",
      "Charanchi",
      "Danja",
      "Daura",
      "Dutsin-Ma",
      "Funtua",
      "Ingawa",
      "Jibia",
      "Kafur",
      "Kaita",
      "Kankara",
      "Katsina",
      "Kurfi",
      "Kusada",
      "Mai'Adua",
      "Malumfashi",
      "Mani",
      "Mashi",
      "Rimi",
      "Safana",
      "Zango",
    ],
  },
  {
    state: "Kebbi",
    cities: ["Dandi", "Fakai", "Shanga"],
  },
  {
    state: "Kogi",
    cities: ["Ijumu", "Lokoja"],
  },
  {
    state: "Kwara",
    cities: [
      "Afon",
      "Ajase-Ipo",
      "Baruten",
      "Edu",
      "Ekiti",
      "Ilorin",
      "Ilorin East",
      "Ilorin South",
      "Ilorin West",
      "Irepodun",
      "Isin",
      "Kabba",
      "Lafiagi",
      "Moro",
      "Offa",
      "Okolowo",
      "Omu-Aran",
      "Pategi",
    ],
  },
  {
    state: "Lagos",
    cities: [
      "Agbara-Igbesa",
      "Agege",
      "Ajah",
      "Alimosho",
      "Amuwo Odofin",
      "Apapa",
      "Ayobo",
      "Badagry",
      "Egbe",
      "Ejigbo",
      "Eko Atlantic City",
      "Epe",
      "Gbagada",
      "Ibeju",
      "Ibeju Lekki",
      "Idimu",
      "Ifako-Ijaiye",
      "Iganmu",
      "Ijaiye",
      "Ijede",
      "Ijesha",
      "Ikeja",
      "Ikorodu",
      "Ikotun",
      "Ikoyi",
      "Ilashe",
      "Ilupeju",
      "Ipaja",
      "Isheri",
      "Isheri North",
      "Isolo",
      "Itire",
      "Ketu",
      "Kosofe",
      "Lagos Island",
      "Lekki",
      "Magodo",
      "Maryland",
      "Mushin",
      "Ogudu",
      "Ojo",
      "Ojodu",
      "Ojota",
      "Oke-Odo",
      "Orile",
      "Oshodi",
      "Shomolu",
      "Surulere",
      "Tarkwa Bay Island",
      "Victoria Island (VI)",
      "Yaba",
    ],
  },
  {
    state: "Nasarawa",
    cities: ["Karshi", "Karu", "Keffi", "Kokona", "Nasarawa", "Obi"],
  },
  {
    state: "Niger",
    cities: ["Minna", "Rafi", "Suleja"],
  },
  {
    state: "Ogun",
    cities: [
      "Abeokuta North",
      "Abeokuta South",
      "Ado-Odo/Ota",
      "Ago-Iwoye",
      "Ayetoro",
      "Berger, Arepo",
      "Ewekoro",
      "Ibafo",
      "Ifo",
      "Ijebu East",
      "Ijebu North",
      "Ijebu North East",
      "Ijebu Ode",
      "Ijoko",
      "Ilaro",

      "Ikenne",
      "Isheri North",
      "KM 46",
      "Magboro",

      "Makun",
      "Mowe Ofada",
      "Mowe Town",
      "Obafemi Owode",
      "Odeda",
      "Odogbolu",
      "Ogijo",
      "Oke-Aro",
      "Ota",
      "Remo North",
      "Sagamu",
      "Sango Ota",
      "Simawa",
      "Yewa North",
      "Yewa South",
    ],
  },
  {
    state: "Ondo",
    cities: ["Akure", "Ilaje", "Owo"],
  },
  {
    state: "Osun",
    cities: [
      "Boripe",
      "Ede North",
      "Ede South",
      "Ife Central",
      "Ilesa East",
      "Ilesa West",
      "Isokan",
      "Iwo",
      "Osogbo",
    ],
  },
  {
    state: "Oyo",
    cities: [
      "Akinyele",
      "Atiba",
      "Egbeda",
      "Ibadan",
      "Ibadan North",
      "Ibadan North-East",
      "Ibadan North-West",
      "Ibadan South-East",
      "Ibadan South-West",
      "Ibarapa Central",
      "Ibarapa East",
      "Ido",
      "Iseyin",
      "Kajola",
      "Lagelu",
      "Ogbomosho North",
      "Olorunsogo",
      "Oluyole",
      "Surulere",
    ],
  },
  {
    state: "Plateau",
    cities: [
      "Barkin Ladi",
      "Bokkos",
      "Bukuru",
      "Jos",
      "Jos East",
      "Jos North",
      "Jos South",
      "Kanam",
      "Kanke",
      "Kwali",
      "Langtang",
      "Mangu",
      "Mikang",
      "Pankshin",
      "Pankshin",
      "Riyom",
      "Shendam",
      "Shendam",
      "Vwang",
      "Wase",
    ],
  },
  {
    state: "Rivers",
    cities: [
      "Abonnema",
      "Ahoada",
      "Akuku-Toru",
      "Andoni",
      "Asari-Toru",
      "Bonny",
      "Bori",
      "Degema",
      "Eleme",
      "Emohua",
      "Etche",
      "Gokana",
      "Ikwerre",
      "Khana",
      "Obio-Akpor",
      "Ogu-Bolo",
      "Okrika",
      "Omoku",
      "Opobo",
      "Oyigbo",
      "Port Harcourt",
      "Tai",
    ],
  },
  {
    state: "Sokoto",
    cities: ["Bodinga", "Rabah", "Tangaza"],
  },
  {
    state: "Yobe",
    cities: ["Fika", "Geidam"],
  },
  {
    state: "Zamfara",
    cities: [],
  },
];

// Utility functions
export const getCitiesByState = (stateName: string): string[] => {
  const location = nigeriaLocations.find((loc) => loc.state === stateName);
  return location ? location.cities : [];
};

export const getAllStates = (): string[] => {
  return nigeriaStates;
};

export const getAllCities = (): string[] => {
  return nigeriaLocations.reduce((acc, location) => {
    return [...acc, ...location.cities];
  }, [] as string[]);
};

// use google maps api to get the latitude and longitude of a location

export const getLatLng = async (
  location: string,
): Promise<{ lat: number; lng: number }> => {
  const response = await fetch(
    `https://maps.googleapis.com/maps/api/geocode/json?address=${location}&key=${process.env.NEXT_PUBLIC_GOOGLE_PLACES_API_KEY}`,
  );
  const data = await response.json();
  const { lat, lng } = data.results[0].geometry.location;
  return { lat, lng };
};

// use google maps api to get the distance between two locations
export const getDistance = async (
  origin: string,
  destination: string,
): Promise<number> => {
  const response = await fetch(
    `https://maps.googleapis.com/maps/api/distancematrix/json?units=metric&origins=${origin}&destinations=${destination}&key=${process.env.NEXT_PUBLIC_GOOGLE_PLACES_API_KEY}`,
  );
  const data = await response.json();
  const distance = data.rows[0].elements[0].distance.value;
  return distance;
};

// use google maps api to get the address from latitude and longitude (reverse geocoding)
export const getAddress = async (lat: number, lng: number): Promise<string> => {
  const response = await fetch(
    `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${process.env.NEXT_PUBLIC_GOOGLE_PLACES_API_KEY}`,
  );
  const data = await response.json();
  if (data.results && data.results.length > 0) {
    const result = data.results[0]?.address_components[2]?.short_name;
    return result;
  }
  throw new Error("No address found for the given coordinates");
};

// get lot and long from user device
export const getUserLocation = (): Promise<{ lat: number; lng: number }> => {
  return new Promise((resolve, reject) => {
    if (typeof window === "undefined") {
      reject(new Error("Window is not available"));
      return;
    }

    if (!navigator.geolocation) {
      reject(new Error("Geolocation is not supported"));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      },
      (error) => {
        switch (error.code) {
          case error.PERMISSION_DENIED:
            reject(new Error("Location permission denied"));
            break;
          case error.POSITION_UNAVAILABLE:
            reject(new Error("Location unavailable"));
            break;
          case error.TIMEOUT:
            reject(new Error("Location request timed out"));
            break;
          default:
            reject(new Error("Unknown location error"));
        }
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      },
    );
  });
};
